import { SHStack } from "@components/design-systems";
import { memo } from "react";

interface SummaryPortfolioCompositionRowTitleProps {
  title?: string;
}

export const SummaryPortfolioCompositionRowTitle = memo(
  ({ title }: SummaryPortfolioCompositionRowTitleProps) => {
    return (
      <SHStack
        width={"100%"}
        height={"100%"}
        alignItems={"start"}
        justifyContent={"center"}
      >
        {title}
      </SHStack>
    );
  },
);
